import * as React from "react"

const QuickbooksIcon = ({ className, width, height }) => {
  return (
    <svg
      fill="none"
      className={className}
      height={height}
      width={width}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m10 20c5.5229 0 10-4.4771 10-10 0-5.52283-4.4771-10-10-10-5.52283 0-10 4.47717-10 10 0 5.5229 4.47717 10 10 10z"
        fill="#2ca01c"
      />
      <path
        d="m2.77661 9.99958c0 2.14772 1.74112 3.88882 3.88889 3.88882h.55556v-1.4444h-.55556c-1.34786 0-2.44444-1.0966-2.44444-2.44442 0-1.34792 1.09658-2.44444 2.44444-2.44444h1.33503v7.55546c0 .7978.6467 1.4445 1.44445 1.4445v-10.44441s-1.49481 0-2.77948 0c-2.14777 0-3.88889 1.74114-3.88889 3.88889zm10.55759-3.88833h-.5556v1.44444h.5556c1.3478 0 2.4444 1.09658 2.4444 2.44441 0 1.3479-1.0966 2.4445-2.4444 2.4445h-1.3351s0-7.41263 0-7.55558c0-.79777-.6467-1.44444-1.4444-1.44444v10.44442h2.7795c2.1477 0 3.8889-1.7412 3.8889-3.8889 0-2.14771-1.7412-3.88885-3.8889-3.88885z"
        fill="#fff"
      />
    </svg>
  )
}

export default QuickbooksIcon
